import { QUIZ_CATEGORIES } from "./questionnaire";

/**
 * Usage:
 * ```tsx
 * import { useLpCtaText } from "~/hooks/useLpCtaText";
 *
 * const ctaText = useLpCtaText("See If Oestra® Is Right for You");
 *
 * <Button>{ctaText}</Button>
 * ```
 */
export const LP_CTA_COPY_BY_VARIANT = {
    see_if_you_qualify: "See If You Qualify",
    start_the_quiz: "Start the Quiz",
    check_your_eligibility: "Check Your Eligibility",
    get_started: "Get Started",
    take_the_2_min_quiz: "Take the 2-Min Quiz",
    start_my_assessment: "Start My Assessment",
    am_i_a_candidate: "Am I a Candidate?",
    discover_whats_right_for_me: "Discover What's Right for Me",
    start_my_journey: "Start My Journey",
    im_ready_to_feel_better: "I'm Ready to Feel Better",
    get_my_prescription_plan: "Get My Prescription Plan",
    start_my_free_visit: "Start My Free Visit",
} as const;

export const TRUSTED_REVIEWS_CATEGORY_BY_VARIANT = {
    top: QUIZ_CATEGORIES.OESTRA_CREAM_REDESIGN_REVIEWS_TOP,
    white: QUIZ_CATEGORIES.OESTRA_CREAM_REDESIGN_REVIEWS_WHITE,
    yellow: QUIZ_CATEGORIES.OESTRA_CREAM_REDESIGN_REVIEWS_YELLOW,
} as const;